export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    openSearchForm({commit}) {
        commit('setSearchFormOpen');
    },
    closeSearchForm({commit}) {
        commit('setSearchFormClose');
    }
}
